import $ from 'jquery'

import { button } from '../../../component/component'

import form from '../edit/form/form'

export default function(e, o, d){

  var generateButton = function(label, type){
    var b =
      button(label,'fi-plus')
        .css({
          display: 'block',
        })
        .click(function(e){
          insert(type)
        })
    return b
  }

  var insert = function(type){

    switch(type){
      case 'aa_marker':
        var model = o.model.aaMarkers
        break
      case 'a_marker':
        var model = o.model.aMarkers
        break
      case 'user_marker':
        var model = o.model.userMarkers
        break
    }

    var d = function(item){
      div.remove()
      o.search.update()
    }

    var c = function(item){
      div.remove()
    }

    var div =
      $('<div>')
      .css({
        position: 'fixed',
        top: '402px',
        width: '400px',
        left: 0,
        bottom: 0,
      })
      .append(
        form(o,model,null,d,c)
      )

    o.edit.append(div)

    menu.remove()

  }

  var x = d.offset().left + d.outerWidth()
  var y = d.offset().top

  var overlay =
    $('<div>')
    .css({
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
    })
    .click(function(){
      menu.remove()
    })

  var buttons =
    $('<div>')
    .css({
      position: 'absolute',
      left: x,
      top: y,
    })
    .append([
      generateButton('anti-archive marker','aa_marker'),
      generateButton('archive marker','a_marker'),
      generateButton('user marker','user_marker'),
    ])

  var menu =
    $('<div>')
    .css({
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    })
    .append([
      overlay,
      buttons,
    ])

  $('body')
  .append(menu)

  e.preventDefault()
  // e.stopPropagation()

  // return false

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/insertMarker.js